import SpriteSymbol from "../../../../ProSpace/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../ProSpace/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 8 4",
  "content": "<symbol viewBox=\"0 0 8 4\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-down\">\n    <path d=\"M6.92969 1.07422L4.44922 3.57422C4.3125 3.69141 4.15625 3.75 4 3.75C3.82422 3.75 3.66797 3.69141 3.55078 3.57422L1.07031 1.07422C0.875 0.898438 0.816406 0.625 0.914062 0.390625C1.01172 0.15625 1.24609 0 1.5 0H6.48047C6.73438 0 6.94922 0.15625 7.04688 0.390625C7.14453 0.625 7.10547 0.898438 6.92969 1.07422Z\" fill=\"#5B7692\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol